import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { AlertService } from "src/app/services/alert.service";

@Component({
    selector: 'alert',
    templateUrl: './alert.component.html',
    standalone: false
})
export class AlertComponent implements OnInit, OnDestroy {
    // @Input() message : string;
    message: any = { class: 'bg-success', text: '' };
    private subscription: Subscription;
    constructor(private _alert: AlertService){}
    ngOnInit(){
        this.subscription = this._alert.getAlert()
            .subscribe(alert => {
                this.message = alert;
                this._alert.showAlert();
            });
    }

    ngOnDestroy(){
        this.subscription.unsubscribe();
    }
}